import React from 'react';
import PropTypes from 'prop-types';
function FeatureContainer({ children }) {
  return <div className="feature-container">{children}</div>;
}
FeatureContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
};
export default FeatureContainer;
